// A specific order is wanted for categories, hence a custom list and ordering must be maintained
// here on the client. If any additional categories are added, they should be accounted for here.
export const BrightbackCategoryOrder = [
  'Product',
  'Needs',
  'Pricing',
  'Execution',
  'Customer experience',
  'Company',
  'Shipping & handling',
];

export const BrightbackClassOrder = ['SaaS', 'Digital', 'eCommerce', 'Other'];
